import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import Dropdown from 'common/components/Dropdown';

const renderDefault = () => <div className="text">kg</div>;
const renderUnit = unit => (
  <div key={unit.id} data-value={unit.id} className="item">
    {unit.label}
  </div>
);

class QuantityField extends Component {
  constructor(props) {
    super(props);

    this._onValueChange = this._onValueChange.bind(this);
    this._onUnitChange = this._onUnitChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  _onValueChange(evt) {
    const { unit } = this.props;

    const value = evt.target.value;
    if (value && value.length && !isNaN(value)) {
      this._onChange({
        value,
        unit,
      });
    }
  }

  _onUnitChange(val) {
    const { value } = this.props;

    if (value) {
      this._onChange({
        value,
        unit: val,
      });
    }
  }

  _onChange(values) {
    this.props.onChange(values);
  }

  render() {
    const { value, unit, units } = this.props;

    return (
      <div className="ui right labeled input">
        <input
          className="seven wide"
          type="number"
          value={value}
          onChange={this._onValueChange}
        />
        <Dropdown
          name="quantity_unit_ref"
          value={unit}
          items={units}
          selection={false}
          renderDefault={renderDefault}
          renderItem={renderUnit}
          className="seven wide basic label"
          rightDropdown
          onChange={this._onUnitChange}
        />
      </div>
    );
  }
}

QuantityField.propTypes = {
  value: PropTypes.any,
  unit: PropTypes.any,
  units: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

QuantityField.defaultProps = {
  value: '',
};

export default QuantityField;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/QuantityField.js